import React, {useEffect, useState} from "react";

import './recording-charts.scss'

import {ComboChart} from "@carbon/charts-react";
import {useRecoilValue} from "recoil";
import {grpcCustomerServiceSelector} from "../../state/grpc";
import DateObject from "react-date-object";
import PropTypes from "prop-types";
import moment from "moment/moment";

const RecordingSystemStats = ({dateRef}) => {
  const systemService = useRecoilValue(grpcCustomerServiceSelector)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [stats, setStats] = useState([])

  useEffect(() => {
    const req = new proto.api.GetSystemRecordingsStatsRequest()
    req.setFromDate(moment(dateRef).startOf("day").startOf("month").format("DD/MM/YYYY hh:mm:ss"))
    req.setToDate(moment(dateRef).endOf("day").endOf("month").format("DD/MM/YYYY hh:mm:ss"))
    systemService.getSystemRecordingsStats(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        setError(true)
      } else {
        let dateObject = new DateObject();
        dateObject._format = "DD/MM/YYYY";
        const stats = resp.toObject().systemrecordingstatsList.map((entry) => {
          return {
            group: entry.systemname,
            key: dateObject.parse(entry.dateref).format("DD/MM"),
            value: Number(entry.durationminutes)
          }
        })
        setStats(stats)
      }
      setLoading(false)
    })
  }, [dateRef]);

  const options = {
    title: 'Rendicontazioni per sistema',
    legend: {
      enabled: false,
    },
    axes: {
      left: {
        title: 'Minuti totali',
        mapsTo: 'value',
        stacked: true
      },
      bottom: {
        title: 'Data',
        mapsTo: 'key',
        scaleType: 'labels'
      }
    },
    data: {
      loading: loading || error,
    },
    comboChartTypes: [
      {
        type: 'stacked-bar',
        options: {},
        correspondingDatasets: stats.map(stat => stat.group)
      },
    ],
    height: '400px'
  }

  return (
    <ComboChart
      data={stats}
      options={options}
    />
  )
}

RecordingSystemStats.propTypes = {
  dateRef: PropTypes.object.isRequired,
}

export default RecordingSystemStats